// components/StudentEditForm.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from '../../url';
import { getFeeCategoryDisplayName } from '../../utils';

const StudentEditForm = ({ 
  student, 
  studentId, 
  onSave, 
  onCancel,
  isOpen,
  showAdmissionNumber = false,
  useDataTableEndpoint = false   // New prop to control admission number visibility/editing
}) => {
  const [formData, setFormData] = useState({
    admissionType: "",
    allotmentCategory: "",
    feeCategory: "",
    name: "",
    address: "",
    permanentAddress: "",
    pincode: "",
    religion: "",
    community: "",
    category: "",
    gender: "",
    dateOfBirth: "",
    bloodGroup: "",
    mobileNo: "",
    whatsappNo: "",
    email: "",
    entranceExam: "",
    entranceRollNo: "",
    entranceRank: "",
    aadharNo: "",
    course: "",
    annualIncome: "",
    nativity: "",
    admissionNumber: "",  // This will be editable when showAdmissionNumber is true
    submissionDate: "",   // NEW FIELD
    qualify: {
      exam: "",
      board: "",
      regNo: "",
      examMonthYear: "",
      percentage: "",
      cgpa: "",
      institution: "",
    },
    parentDetails: {
      fatherName: "",
      fatherOccupation: "",
      fatherMobileNo: "",
      motherName: "",
      motherOccupation: "",
      motherMobileNo: "",
    },
    bankDetails: {
      bankName: "",
      branch: "",
      accountNo: "",
      ifscCode: "",
    },
    achievements: {
      arts: "",
      sports: "",
      other: "",
    },
    marks: {
      boardType: "",
      physics: "",
      chemistry: "",
      maths: "",
    },
    certificates: {
      tenth: false,
      plusTwo: false,
      tcandconduct: false,
      allotmentmemo: false,
      Datasheet: false,
      physicalfitness: false,
      passportsizephoto: false,
      incomecertificates: false,
      communitycertificate: false,
      castecertificate: false,
      aadhaar: false,
      marklist: false,
      degreecertificates: false,
      other: false,
    },
  });

  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (student) {
      const formattedDateOfBirth = student.dateOfBirth 
        ? new Date(student.dateOfBirth).toISOString().split("T")[0]
        : "";
      
      const formattedSubmissionDate = student.submissionDate 
        ? new Date(student.submissionDate).toISOString().split("T")[0]
        : "";
      
      setFormData({
        admissionType: student.admissionType || "",
        allotmentCategory: student.allotmentCategory || "",
        feeCategory: student.feeCategory || "",
        name: student.name || "",
        address: student.address || "",
        permanentAddress: student.permanentAddress || "",
        pincode: student.pincode || "",
        religion: student.religion || "",
        community: student.community || "",
        category: student.category || "",
        gender: student.gender || "",
        dateOfBirth: formattedDateOfBirth,
        bloodGroup: student.bloodGroup || "",
        mobileNo: student.mobileNo || "",
        whatsappNo: student.whatsappNo || "",
        email: student.email || "",
        entranceExam: student.entranceExam || "",
        entranceRollNo: student.entranceRollNo || "",
        entranceRank: student.entranceRank || "",
        aadharNo: student.aadharNo || "",
        course: student.course || "",
        annualIncome: student.annualIncome || "",
        nativity: student.nativity || "",
        admissionNumber: student.admissionNumber || "",
        submissionDate: formattedSubmissionDate || student.submissionDate || "",
        qualify: {
          exam: student.qualify?.exam || "",
          board: student.qualify?.board || "",
          regNo: student.qualify?.regNo || "",
          examMonthYear: student.qualify?.examMonthYear || "",
          percentage: student.qualify?.percentage || "",
          cgpa: student.qualify?.cgpa || "",
          institution: student.qualify?.institution || "",
        },
        parentDetails: {
          fatherName: student.parentDetails?.fatherName || "",
          fatherOccupation: student.parentDetails?.fatherOccupation || "",
          fatherMobileNo: student.parentDetails?.fatherMobileNo || "",
          motherName: student.parentDetails?.motherName || "",
          motherOccupation: student.parentDetails?.motherOccupation || "",
          motherMobileNo: student.parentDetails?.motherMobileNo || "",
        },
        bankDetails: {
          bankName: student.bankDetails?.bankName || "",
          branch: student.bankDetails?.branch || "",
          accountNo: student.bankDetails?.accountNo || "",
          ifscCode: student.bankDetails?.ifscCode || "",
        },
        achievements: {
          arts: student.achievements?.arts || "",
          sports: student.achievements?.sports || "",
          other: student.achievements?.other || "",
        },
        marks: {
          boardType: student.marks?.boardType || "",
          physics: student.marks?.physics || "",
          chemistry: student.marks?.chemistry || "",
          maths: student.marks?.maths || "",
        },
        certificates: {
          tenth: student.certificates?.tenth || false,
          plusTwo: student.certificates?.plusTwo || false,
          tcandconduct: student.certificates?.tcandconduct || false,
          allotmentmemo: student.certificates?.allotmentmemo || false,
          Datasheet: student.certificates?.Datasheet || false,
          physicalfitness: student.certificates?.physicalfitness || false,
          passportsizephoto: student.certificates?.passportsizephoto || false,
          incomecertificates: student.certificates?.incomecertificates || false,
          communitycertificate: student.certificates?.communitycertificate || false,
          castecertificate: student.certificates?.castecertificate || false,
          aadhaar: student.certificates?.aadhaar || false,
          marklist: student.certificates?.marklist || false,
          degreecertificates: student.certificates?.degreecertificates || false,
          other: student.certificates?.other || false,
        },
      });
    }
  }, [student]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;

    if (name.startsWith("qualify")) {
      const qualifyField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        qualify: { ...prev.qualify, [qualifyField]: value },
      }));
    } else if (name.startsWith("parentDetails")) {
      const parentField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        parentDetails: { ...prev.parentDetails, [parentField]: value },
      }));
    } else if (name.startsWith("bankDetails")) {
      const bankField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        bankDetails: { ...prev.bankDetails, [bankField]: value },
      }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        certificates: { ...prev.certificates, [name]: checked },
      }));
    } else if (name.includes("marks")) {
      const [, subField] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        marks: { ...prev.marks, [subField]: value },
      }));
    } else if (name.startsWith("achievements")) {
      const achievementField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        achievements: { ...prev.achievements, [achievementField]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const endpoint = useDataTableEndpoint 
        ? `/api/datatable/updateStudent/${studentId}`
        : `/api/updateStudent/${studentId}`;
      
      await axios.put(`${baseurl}${endpoint}`, formData);
      setIsSuccess(true);
      setTimeout(() => setIsSuccess(false), 3000);
      if (onSave) onSave();
    } catch (error) {
      console.error("Error updating student details:", error);
      alert("Error updating student details. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div>
      <h2>Edit Student Details</h2>
      <button onClick={onCancel}>Back to Student Details</button>
      <div className="data-entry-container">
        <div className="page-title">Admission Form</div>
        <hr className="divider" />
        <form className="form" onSubmit={handleSubmit}>
          {/* Admission Number and Submission Date in same row */}
          <div className="row">
            {/* Admission Number - Editable only when showAdmissionNumber is true */}
            {showAdmissionNumber && (
              <div className="form-group">
                <label className="required">Admission No:</label>
                <input
                  type="text"
                  name="admissionNumber"
                  value={formData.admissionNumber}
                  onChange={handleInputChange}
                  required
                  placeholder="e.g., 01/24"
                />
              </div>
            )}

            {/* Show read-only admission number when not editable */}
            {!showAdmissionNumber && formData.admissionNumber && (
              <div className="form-group">
                <label>Admission No:</label>
                <input
                  type="text"
                  value={formData.admissionNumber}
                  readOnly
                  disabled
                  style={{ backgroundColor: '#f0f0f0' }}
                />
              </div>
            )}

            {/* Submission Date - in same row as Admission Number */}
            <div className="form-group">
              <label>Submission Date:</label>
              <input
                type="date"
                name="submissionDate"
                value={formData.submissionDate}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label className="required">Admission Type:</label>
              <select
                name="admissionType"
                value={formData.admissionType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Admission Type</option>
                <option value="KEAM">KEAM</option>
                <option value="LBS-MCA">LBS-MCA</option>
                <option value="SPOT">SPOT</option>
                <option value="LET">LET</option>
              </select>
            </div>

            <div className="form-group">
              <label className="required">Allotment Category:</label>
              <select
                name="allotmentCategory"
                value={formData.allotmentCategory}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Allotment Category</option>
                <option value="State Merit">SM</option>
                <option value="Management">MG</option>
              </select>
            </div>

            <div className="form-group">
              <label>Fee Category:</label>
              <select
                name="feeCategory"
                value={formData.feeCategory}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Fee Category</option>
                <option value="Merit Lower Fee">Merit Low Fee</option>
                <option value="Merit Higher Fee">Merit Full Fee</option>
                <option value="Fee wavier">FW</option>
              </select>
            </div>

            <div className="form-group">
              <label className="required">Course:</label>
              <select
                value={formData.course}
                onChange={(e) =>
                  setFormData({ ...formData, course: e.target.value })
                }
              >
                <option value="">Select Course</option>
                <option value="B.Tech CSE">B.Tech CSE</option>
                <option value="B.Tech ECE">B.Tech ECE</option>
                <option value="BBA">BBA</option>
                <option value="BCA">BCA</option>
                <option value="MCA">MCA</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Permanent Address:</label>
            <input
              type="text"
              name="permanentAddress"
              value={formData.permanentAddress}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Pin Code:</label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="row">
            <div className="form-group">
              <label>Religion:</label>
              <input
                type="text"
                name="religion"
                value={formData.religion}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Community:</label>
              <input
                type="text"
                name="community"
                value={formData.community}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label className="required">Category:</label>
              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label>Gender:</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Transgender">Transgender</option>
                <option value="Prefer to not say">Prefer to not say</option>
              </select>
            </div>
            <div className="form-group">
              <label>Blood Group:</label>
              <input
                type="text"
                name="bloodGroup"
                value={formData.bloodGroup}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Date Of Birth:</label>
            <input
              type="date"
              name="dateOfBirth"
              value={formatDateForInput(formData.dateOfBirth)}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile No:</label>
            <input
              type="tel"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleInputChange}
              required
              pattern="[0-9]{10}"
              title="Please enter a valid 10-digit phone number"
            />
          </div>

          <div className="form-group">
            <label>WhatsApp No:</label>
            <input
              type="tel"
              name="whatsappNo"
              value={formData.whatsappNo}
              onChange={handleInputChange}
              required
              pattern="[0-9]{10}"
              title="Please enter a valid 10-digit phone number"
            />
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Aadhar No:</label>
            <input
              type="text"
              name="aadharNo"
              value={formData.aadharNo}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="parent-details-row">
            <div className="form-group">
              <label>Entrance Exam Name:</label>
              <input
                type="text"
                name="entranceExam"
                value={formData.entranceExam}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Entrance Roll No:</label>
              <input
                type="text"
                name="entranceRollNo"
                value={formData.entranceRollNo}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Entrance Rank:</label>
              <input
                type="text"
                name="entranceRank"
                value={formData.entranceRank}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="box">
            <h4>Qualifying Examination Details</h4>
            <div className="parent-details-row">
              <div className="form-group">
                <label>Qualification:</label>
                <input
                  type="text"
                  name="qualify.exam"
                  value={formData.qualify.exam}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Board:</label>
                <input
                  type="text"
                  name="qualify.board"
                  value={formData.qualify.board}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Institution:</label>
                <input
                  type="text"
                  name="qualify.institution"
                  value={formData.qualify.institution}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Register No:</label>
                <input
                  type="text"
                  name="qualify.regNo"
                  value={formData.qualify.regNo}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Exam Month and Year:</label>
                <input
                  type="text"
                  name="qualify.examMonthYear"
                  value={formData.qualify.examMonthYear}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Percentage:</label>
                <input
                  type="text"
                  name="qualify.percentage"
                  value={formData.qualify.percentage}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>CGPA:</label>
                <input
                  type="text"
                  name="qualify.cgpa"
                  value={formData.qualify.cgpa}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {(formData.course === "B.Tech CSE" || formData.course === "B.Tech ECE") && (
            <div className="form-group">
              <div className="box">
                <h4>Plus Two Mark</h4>
                <label className="required">(Please Enter Plus Two Mark Only)</label>
                <div className="radio-group-row">
                  <label>
                    <input
                      type="radio"
                      name="marks.boardType"
                      value="State"
                      checked={formData.marks.boardType === "State"}
                      onChange={handleInputChange}
                    />
                    <span></span> State
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="marks.boardType"
                      value="CBSE"
                      checked={formData.marks.boardType === "CBSE"}
                      onChange={handleInputChange}
                    />
                    <span></span> CBSE
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="marks.boardType"
                      value="ICSE"
                      checked={formData.marks.boardType === "ICSE"}
                      onChange={handleInputChange}
                    />
                    <span></span> ICSE
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="marks.boardType"
                      value="Others"
                      checked={formData.marks.boardType === "Others"}
                      onChange={handleInputChange}
                    />
                    <span></span> Others
                  </label>
                </div>

                <div className="row">
                  <label>
                    Physics Marks:
                    <input
                      type="number"
                      name="marks.physics"
                      value={formData.marks.physics}
                      onChange={handleInputChange}
                    />
                  </label>
                  <label>
                    Chemistry Marks:
                    <input
                      type="number"
                      name="marks.chemistry"
                      value={formData.marks.chemistry}
                      onChange={handleInputChange}
                    />
                  </label>
                  <label>
                    Maths Marks:
                    <input
                      type="number"
                      name="marks.maths"
                      value={formData.marks.maths}
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
              </div>
            </div>
          )}

          <div className="box">
            <h4>Parent Details</h4>
            <div className="parent-details-row">
              <div className="form-group">
                <label>Father Name:</label>
                <input
                  type="text"
                  name="parentDetails.fatherName"
                  value={formData.parentDetails.fatherName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Mother Name:</label>
                <input
                  type="text"
                  name="parentDetails.motherName"
                  value={formData.parentDetails.motherName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Father Occupation:</label>
                <input
                  type="text"
                  name="parentDetails.fatherOccupation"
                  value={formData.parentDetails.fatherOccupation}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Mother Occupation:</label>
                <input
                  type="text"
                  name="parentDetails.motherOccupation"
                  value={formData.parentDetails.motherOccupation}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Father Mobile No:</label>
                <input
                  type="tel"
                  name="parentDetails.fatherMobileNo"
                  value={formData.parentDetails.fatherMobileNo}
                  onChange={handleInputChange}
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit phone number"
                />
              </div>
              <div className="form-group">
                <label>Mother Mobile No:</label>
                <input
                  type="tel"
                  name="parentDetails.motherMobileNo"
                  value={formData.parentDetails.motherMobileNo}
                  onChange={handleInputChange}
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit phone number"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label>Annual Income:</label>
              <input
                type="text"
                name="annualIncome"
                value={formData.annualIncome}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Nativity:</label>
              <input
                type="text"
                name="nativity"
                value={formData.nativity}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="box">
            <h4>Bank Details</h4>
            <div className="parent-details-row">
              <div className="form-group">
                <label>Bank Name:</label>
                <input
                  type="text"
                  name="bankDetails.bankName"
                  value={formData.bankDetails.bankName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Branch:</label>
                <input
                  type="text"
                  name="bankDetails.branch"
                  value={formData.bankDetails.branch}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Account No:</label>
                <input
                  type="text"
                  name="bankDetails.accountNo"
                  value={formData.bankDetails.accountNo}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>IFSC Code:</label>
                <input
                  type="text"
                  name="bankDetails.ifscCode"
                  value={formData.bankDetails.ifscCode}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="box">
            <h4>Achievements</h4>
            <div className="row">
              <div className="form-group">
                <label>Arts:</label>
                <input
                  type="text"
                  name="achievements.arts"
                  value={formData.achievements.arts}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Sports:</label>
                <input
                  type="text"
                  name="achievements.sports"
                  value={formData.achievements.sports}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Other:</label>
                <input
                  type="text"
                  name="achievements.other"
                  value={formData.achievements.other}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="checkbox-container">
            <label className="required">Submitted Certificates</label>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="tenth"
                name="tenth"
                checked={formData.certificates.tenth}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="tenth">10th Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="plusTwo"
                name="plusTwo"
                checked={formData.certificates.plusTwo}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="plusTwo">12th Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="tcandconduct"
                name="tcandconduct"
                checked={formData.certificates.tcandconduct}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="tcandconduct">TC and Conduct Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="allotmentmemo"
                name="allotmentmemo"
                checked={formData.certificates.allotmentmemo}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="allotmentmemo">Allotment Memo</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="Datasheet"
                name="Datasheet"
                checked={formData.certificates.Datasheet}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="Datasheet">Data Sheet</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="physicalfitness"
                name="physicalfitness"
                checked={formData.certificates.physicalfitness}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="physicalfitness">Physical Fitness</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="aadhaar"
                name="aadhaar"
                checked={formData.certificates.aadhaar}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="aadhaar">Copy of Aadhaar Card</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="passportsizephoto"
                name="passportsizephoto"
                checked={formData.certificates.passportsizephoto}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="passportsizephoto">Passportsize Photo (2 Nos)</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="incomecertificates"
                name="incomecertificates"
                checked={formData.certificates.incomecertificates}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="incomecertificates">Income Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="communitycertificate"
                name="communitycertificate"
                checked={formData.certificates.communitycertificate}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="communitycertificate">Community Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="castecertificate"
                name="castecertificate"
                checked={formData.certificates.castecertificate}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="castecertificate">Caste Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="degreecertificates"
                name="degreecertificates"
                checked={formData.certificates.degreecertificates}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="degreecertificates">Degree/Diploma Certificate</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="marklist"
                name="marklist"
                checked={formData.certificates.marklist}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="marklist">Mark List</label>
            </div>
            <div className="checkbox-custom">
              <input
                type="checkbox"
                id="other"
                name="other"
                checked={formData.certificates.other}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              <label htmlFor="other">Other</label>
            </div>
          </div>

          <div className="button-container">
            <button type="submit" className="submit-button">
              Save
            </button>
            <button type="button" className="clear-button" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      {isSuccess && <p>Update successful!</p>}
    </div>
  );
};

export default StudentEditForm;